import React from 'react';
import { Icon, IconProps } from './Icon';

export const Pickup: React.FC<IconProps> = (props) => {
  const color = props.color || props.fill || 'black';

  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 1200 1200"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M199.88,529.57l82.84-294.54c1.29-6.29,8.43-12.39,16.81-12.39h677.03c8.39,0,15.52,6.11,16.81,14.39l82.84,294.54"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="50"
        />
        <path
          d="M397.39,703.36h661.8c9.4,0,17.02-7.62,17.02-17.02v-132.88h-356.73c0,.25,0,.49,0,.74,0,44.98-36.46,81.45-81.45,81.45s-81.45-36.46-81.45-81.45c0-.25,0-.49,0-.74h-94.76"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="50"
        />
        <path
          d="M342.64,553.46h-142.75v132.88"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="50"
        />
        <line
          x1="474.13"
          y1="553.46"
          x2="919.68"
          y2="553.46"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="50"
        />
      </g>
      <path
        d="M99.79,976.49s70.48,10.21,158.92-39.1c84.48-47.1,184.64-129.65,258.95-129.65h186.39c28.59,0,51.99-23.39,51.99-51.99h0c0-28.59-23.39-51.99-51.99-51.99h-336.01c-8.99,0-13.5-10.88-7.14-17.24l44.73-33.43c29.27-21.87,55.34-50.07,51.98-89.71-.82-9.64-5.76-21.31-9.84-27.49-3.21-4.87-7.31-9.12-12.18-12.33-20.16-13.28-47.71-11.07-65.4,6.62l-91.6,91.6-177.95,177.95"
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeMiterlimit="10"
        strokeWidth="50"
      />
    </Icon>
  );
};
